import { format } from 'date-fns';
import type { DashboardSnapshot, DayState } from '@daily/shared';
import { useClock } from '@/hooks/useClock';

interface TopBarProps {
  dashboard: DashboardSnapshot;
  dayState: DayState;
}

const GREETING_VERB: Record<DayState, string> = {
  morning: 'Good morning',
  afternoon: 'Good afternoon',
  evening: 'Good evening',
  night: 'Goodnight',
};

export function TopBar({ dashboard, dayState }: TopBarProps) {
  const now = useClock(15_000);
  const dateStr = format(now, 'EEE d MMM');
  const timeStr = format(now, 'HH:mm');

  return (
    <div className="col-span-full flex justify-between items-center pb-2 px-1">
      <div className="font-serif italic text-[24px] text-ink leading-none">
        {GREETING_VERB[dayState]}, <em className="text-tomato">family</em>.
      </div>
      <div className="font-serif text-[18px] text-inkSoft flex items-center gap-3">
        <span>{dateStr}</span>
        <span className="w-[5px] h-[5px] bg-inkFaded rounded-full" />
        <span>{timeStr}</span>
        <span className="w-[5px] h-[5px] bg-inkFaded rounded-full" />
        <span className="text-tomato">
          {dashboard.weather.temperatureC}° {dashboard.weather.condition}
        </span>
      </div>
    </div>
  );
}
